module.exports = __webpack_public_path__ + "img/57.0bafaf7c.jpg";